import { Card } from '@etiquette-ui/misc';
import styled from 'styled-components';

const FormSection = styled(Card)`
  padding: 20px 24px;
  margin-bottom: 20px;

  @media( max-width: 768px ){
    padding: 15px 15px 20px 15px;
    box-shadow: unset!important;
    border-radius: 8px;

    width: 95%;
    margin: -1px auto 10px auto;
  }
`;

export default FormSection;